import React, { useContext } from "react";
import "./terms.css";
import { MyContext } from "../../Context/MyContext";

const TermsConditions = () => {
  const { termsData } = useContext(MyContext);
  const { title, description, sections } = termsData || {};
  const safeSections = Array.isArray(sections) ? sections : [];

  return (
    <section className="terms-container">
      <br /><br />
      <div className="terms-wrapper">
        <div className="terms-content full-width">
          <h2>{title}</h2>
          <p>{description}</p>
          <div className="terms-sections">
            {safeSections.map((item) => (
              <div key={item.id} className="terms-card">
                <h3>{item.title}</h3>
                <p>{item.content}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default TermsConditions;